import {
    ViewDashboard,
    ViewDatabaseGuard,
    ViewTopBar,
    ViewNewExperienceSection,
    ViewNavigationSidebar,
} from "@/ui/compositionRootUI";
import LayoutFullScreen from "@/ui/layouts/LayoutFullScreen";
import ErrorBoundary from "@/ui/organisms/ErrorBoundary";

import { dashboardTabsValidator, routerPaths } from "@/ui/router/routerPaths";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const PageDashboard = () => {
    const navigate = useNavigate();
    const { tab } = useParams() as {
        tab: string;
    };

    useEffect(() => {
        const isValidTab = dashboardTabsValidator(tab);
        if (isValidTab) return;
        navigate(routerPaths.dashboard.read("deal"));
    }, [navigate, tab]);

    return (
        <LayoutFullScreen
            TopBarProps={{
                sx: {
                    backgroundColor: "var(--proda-white-110)",
                },
            }}
            MainContentProps={{
                sx: {
                    backgroundColor: "var(--proda-white)",
                    borderTop: "1px solid var(--primary-color)",
                },
            }}
            contentTopBar={<ViewTopBar />}
            contentTopBarBanner={<ViewNewExperienceSection />}
            contentSidebar={<ViewNavigationSidebar />}
        >
            <ErrorBoundary>
                <ViewDatabaseGuard>
                    {dashboardTabsValidator(tab) && (
                        <ViewDashboard
                            activeTab={tab}
                            setActiveTab={targetTabName => {
                                navigate(
                                    routerPaths.dashboard.read(targetTabName),
                                );
                            }}
                        />
                    )}
                </ViewDatabaseGuard>
            </ErrorBoundary>
        </LayoutFullScreen>
    );
};

export default PageDashboard;
